import { createFileRoute } from "@tanstack/react-router";
import GruhUdhyogShowcase from "@project/user/pages/programs/gruh-udhyog";

export const Route = createFileRoute("/_user/_programs/gruh-udhyog")({
  head: () => ({
    meta: [
      { title: "Gruh Udhyog — Jivandhara Mahila Utkarsh Kendra" },
      {
        name: "description",
        content:
          "Snacks, pickles, spices, sweets and handicrafts — made with love by the artisans of Jivandhara.",
      },
      { property: "og:title", content: "Gruh Udhyog — Jivandhara Mahila Utkarsh Kendra" },
    ],
  }),
  component: GruhUdhyogShowcase,
});
